import React from "react";
import { AppLayout } from "../../Layouts";
import PageLayout from "../../Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { ProductsCategoriesContent } from "../../Components";

export function ProductsCategories() {
  const { t } = useTranslation();
  return (
    <AppLayout>
      <PageLayout title={t("products-categories")} subtitle="231 entries found">
        <div className="h-fit max-w-1/2  bg-white rounded-xl shadow-accent-foreground shadow-2xl p-4">
          <ProductsCategoriesContent />
        </div>
      </PageLayout>
    </AppLayout>
  );
}
